export default __webpack_public_path__ + "static/media/backgroundDark.c8ade2ff.png";